import React from "react";

export const AboutExportStatus = () => {

    return(
        <>
        <div className="contentBox">
            <div>
                <div className="left">
                    <div className="imgBox">
                        <img src="/assets/images/export_status_map.png" alt="수출현황 지도"/>
                    </div>
                </div>
                <div className="right">
                    <div>
                        <ul>
                            <li>France</li>
                            <li>Italy</li>
                            <li>Morocco</li>
                            <li>Qatar</li>
                            <li>Algeria</li>
                            <li>Venezuela</li>
                            <li>Chile</li>
                            <li>Panama</li>
                            <li>Sri Lanka</li>
                            <li>Maldives</li>
                        </ul>
                        <ul>
                            <li>Mauritius</li>
                            <li>Vietnam</li>
                            <li>Philippines</li>
                            <li>Indonesia</li>
                            <li>Australia</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}